import { IState } from '../../store';

export const selectIsDemandRequestOpen = (state: IState) => state.requestDemand.isDemandRequestOpen;
